<template>
    <!-- use the rates table tr electricity component if this is a row in the electricity table -->
    <rates-table-tr-electricity v-if="name == 'Electricity' && meter == 1 && hasSingle || name == 'Stroom'  && meter == 1 && hasSingle" :proposition="proposition" :name="name"></rates-table-tr-electricity>

    <rates-table-tr-electricity-double v-else-if="name == 'Electricity' && meter == 2 && hasDouble || name == 'Stroom' && meter == 2 && hasDouble" :proposition="proposition" :name="name"></rates-table-tr-electricity-double>

    <!-- use the rates table tr gas component if this is a row in the gas table -->
    <rates-table-tr-gas v-else-if="name == 'Gas' && hasGas" :proposition="proposition" :name="name"></rates-table-tr-gas>

    <div v-else style="display: contents">
      <tr>
        <td width="60%" class="d-sm-table-cell font-weight-bold">
          <u>{{ name }}</u>
        </td>
        <td class="" style="font-size: 9px">
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
        </td>
        <td class="" style="font-size: 9px">
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
        </td>
        <td class="text-center" style="font-size: 9px">
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
        </td>
        <td class="text-right" style="font-size: 9px">
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
          <i class="fa fa-asterisk fa-spin"></i>
        </td>
      </tr>
    </div>
</template>

<script>
import { mapState } from "vuex";
import RatesTableTrElectricity from './RatesTableTrElectricity.vue';
import RatesTableTrElectricityDouble from './RatesTableTrElectricityDouble.vue';
import RatesTableTrGas from './RatesTableTrGas.vue';
export default {
  components: { RatesTableTrElectricity, RatesTableTrGas, RatesTableTrElectricityDouble },
  name: "RatesTableTrx",
  props: ["product", "offer", "proposition", "name"],
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
    ...mapState({
      combinations: (state) => state.forms.combinations,
      solar: (state) => state.forms.solar,
      solars: (state) => state.forms.solars,
      consumption: (state) => state.forms.consumption,
      ratesloader: (state) => state.forms.ratesloader,
      meter: (state) => state.forms.meter,
      addressResidential: (state) => state.forms.addressResidential,
      hasSingle() {
        var x = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'rate_single');
        if (x !== undefined) {
          return true;
        }
        return false;
      },
      hasDouble() {
        var x = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'rate_double_high');
        if (x !== undefined) {
          return true;
        }
        return false;
      },
      hasGas() {
        var x = this.overview.find(x => x.group === 'gas').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'usage_gas');
        if (x !== undefined) {
          return true;
        }
        return false;
      },
    }),
    isCrossLeftNetted() {
      if (this.meter === 1) {
        var high = parseInt(this.consumption.electric.double.high) - parseInt(this.solar.high);
        var low = parseInt(this.consumption.electric.double.high) - parseInt(this.solar.high);
        if (high > 0 && low < 0 || low > 0 && high < 0) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
  },
};
</script>

<style scoped></style>
